import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import backarrow from "../../../../assets/images/back-arrow-left.svg";
import closeicon from "../../../../assets/images/close.svg";
import useLanguageTranslate from "../../../../hooks/useLanguageTranslate";
import useScreenResolution from "../../../../hooks/useScreenResolution";
import useTravelRenewalFlow from "../../../../hooks/useTravelRenewalFlow";
import BottomStickyBtnLayout from "../../../motorInsurancePages/newMotorPolicy/Layouts/BottomStickyBtnLayout";

const TravelRenewalLayout = ({
  children,
  is_hide_back_btn,
  show_close_btn,
  handleCloseBtnClick,
  btn_label,
  btn_onClick,
  btn_disabled,
  show_summary,
  is_bottom_sticky_layout = true,
  backClickHandler,
  price,
  onShowSummary,
  isFirstStep = false,
  hideContinueBtn = false,
}) => {
  const navigate = useNavigate();
  const { mobile } = useScreenResolution();
  const { handlePrevSubstep } = useTravelRenewalFlow();
  const translate = useLanguageTranslate();
  const { i18n } = useTranslation();
  const isRTL = i18n.resolvedLanguage === "ar";

  const handleNavigationClick = () => {
    if (isFirstStep || show_close_btn) {
      // Close button - navigate to renewal hub
      if (handleCloseBtnClick) {
        handleCloseBtnClick();
      } else {
        navigate("/renew");
      }
    } else {
      // Back button
      if (backClickHandler) {
        backClickHandler();
      } else {
        handlePrevSubstep();
      }
    }
  };

  const handleCloseClick = () => {
    if (handleCloseBtnClick) {
      handleCloseBtnClick();
    } else {
      navigate("/renew");
    }
  };

  return (
    <div className="">
      {/* Mobile Navigation - Sticky Top Bar */}
      {mobile && !is_hide_back_btn && (
        <div className="sticky top-0 left-0 right-0 bg-white border-b border-gray-100 z-10">
          <div className="flex items-center h-14 px-4 justify-start">
            {/* Navigation Button - Close on first step, Back on subsequent steps */}
            <button
              className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
              onClick={handleNavigationClick}
              aria-label={
                isFirstStep || show_close_btn
                  ? translate("Close", "إغلاق")
                  : translate("Back", "رجوع")
              }
            >
              {isFirstStep || show_close_btn ? (
                <img src={closeicon} alt="Close" className="w-5 h-5" />
              ) : (
                <img
                  src={backarrow}
                  alt="Back"
                  className={`w-5 h-5 ${isRTL ? "rotate-180" : ""}`}
                />
              )}
            </button>
          </div>
        </div>
      )}

      {/* Desktop Navigation */}
      {!mobile && !is_hide_back_btn && (
        <div className="relative">
          {!isFirstStep && !show_close_btn && (
            <button
              className="backButton bg-navy-blue py-2 rounded pt-0 flex absolute left-[26px] rtl:right-[26px] rtl:left-auto top-0 text-black text-sm not-italic font-semibold leading-6 tracking-[-0.084px]"
              onClick={backClickHandler || handlePrevSubstep}
            >
              <img
                src={backarrow}
                alt="Back arrow"
                className="rtl:rotate-180"
              />
              <span className="back-text inline rtl:mr-1">
                {translate("Back", "رجوع")}
              </span>
            </button>
          )}
          {(isFirstStep || show_close_btn) && (
            <button
              className="py-2 rounded mt-20 flex absolute left-[26px] rtl:right-[26px] rtl:left-auto top-0 text-black text-sm not-italic font-semibold leading-6 tracking-[-0.084px]"
              onClick={handleCloseClick}
            >
              <img src={closeicon} alt="Close Icon" className="w-5 h-5" />
            </button>
          )}
        </div>
      )}

      {is_bottom_sticky_layout ? (
        <BottomStickyBtnLayout
          btn_disabled={btn_disabled}
          btn_onClick={btn_onClick}
          passedFrom="TravelRenewal"
          btn_label={btn_label || translate("Continue", "التالي")}
          price={price}
          show_summary={show_summary && !!price && price > 0}
          onShowSummary={onShowSummary}
          hideContinueBtn={hideContinueBtn}
        >
          {children}
        </BottomStickyBtnLayout>
      ) : (
        children
      )}
    </div>
  );
};

export default TravelRenewalLayout;
